import * as reducerType from '../../unit/reducerType';
import { getParam } from '../../unit/const';
import i18n from '../../../i18n.json';

const getInitLan = () => {
  let l = getParam('lan').toLowerCase();
  l = i18n.lan.indexOf(l) === -1 ? i18n.default : l;
  return l;
};

const initState = getInitLan();
const language = (state = initState, action) => {
  switch (action.type) {
    case reducerType.LANGUAGE:
      return action.data;
    default:
      return state;
  }
};

export default language;
